import React from 'react'; 


function InsightPro() {
    return <p>Insight Pro</p>
}

export default InsightPro; 